import axios from 'axios';

// Resolve backend URL.
//
// Why this is more complex than `process.env.REACT_APP_BACKEND_URL`:
// the production bundle is built once and the env var value is baked in at
// build time. If the bundle is then served from a *different* origin (e.g.
// custom domain `eva-ai-assistant.com`) the baked-in URL points at the wrong
// host (the staging/preview env), so every API call cross-origins to a
// different DB and either 401s or fails CORS.
//
// In a production build we therefore prefer `window.location.origin` so the
// frontend always talks to its own backend. In development (`npm start`) we
// honour `REACT_APP_BACKEND_URL` because the dev server typically runs on a
// different host/port than the backend.
function _resolveBackendUrl() {
  const envUrl = (process.env.REACT_APP_BACKEND_URL || '').trim();
  if (typeof window === 'undefined' || !window.location || !window.location.origin) {
    return envUrl;
  }
  // Development: honour env var (dev server origin ≠ backend origin).
  if (process.env.NODE_ENV !== 'production') {
    return envUrl || window.location.origin;
  }
  // Production: always call same-origin. The platform's ingress routes
  // /api/* to the backend, so this works for every deploy host (preview,
  // custom domain, future renames) without rebuilding.
  return window.location.origin;
}

const API_BASE_URL = _resolveBackendUrl() + '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('eva_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 responses
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('eva_token');
      // Show toast before redirect (imported dynamically to avoid circular deps)
      import('sonner').then(({ toast }) => {
        toast.error('Sessione scaduta. Effettua nuovamente il login.');
      });
      setTimeout(() => {
        window.location.href = '/login';
      }, 1000);
    }
    return Promise.reject(error);
  }
);

export default api;
